import React from 'react'
import { useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import './classes/UserTab.css';
import './classes/ViewTab.css';
import './classes/Modal.css';
import Editor, { 
  BtnBold,
  BtnItalic,
  BtnRedo,
  BtnUndo,
  Toolbar
} from 'react-simple-wysiwyg';

import { configData } from "../config";
import EditProfile from './EditProfile';
import EditMentor from './EditMentor';
import EditAgent from './EditAgent';
import EditScout from './EditScout';
import EditAmbassador from './EditAmbassador';
import OrderPage from './OrderPage';
import ReferralPage from './ReferralPage';
import CertificatePage from './CertificatePage';
import ViewSalespersonDashboard from './ViewSalespersonDashboard';
import ViewSaadminDashboard from './ViewSaadminDashboard';
import ViewUserProfile from './ViewUserProfile';
import AgentHome from './AgentHome';
import ScoutHome from './ScoutHome';
import Loading from './Loading';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { Helmet } from 'react-helmet';
import SalespersonSidebar from './SalespersonSidebar';
import AgentBackendSidebar from './AgentBackendSidebar';
import ScoutSidebar from './ScoutSidebar';
import Select from 'react-dropdown-select';
import AdminEditProfile from './AdminEditProfile';

function ViewTab  ()  {
 
  const [toggle, setToggle] = useState(1);

  const[userDetails,setUserDetails] = useState({});
  const[userAssets,setUserAssets] = useState({});
  
   const[userMentorAssets,setUserMentorAssets] = useState({});
   const[userSortflags,setUserSortflags] = useState({});
  const[userLoggedinDetails,setUserLoggedinDetails] = useState({});
  const[userAthleteAssets,setUserAthleteAssets] = useState({});
  const[userAgentAssets,setUserAgentAssets] = useState({});
  const[userScoutAssets,setUserScoutAssets] = useState({});
   const[userAmbassadorAssets,setUserAmbassadorAssets] = useState({});
  const[userSocailMediaAssets,setUserSocailMediaAssets] = useState({});
  const[userCommonAssets,setUserCommonAssets] = useState({});
  const[userLeadAssets,setUserLeadAssets] = useState({});
  const[userEventAssets,setUserEventAssets] = useState({});
  
  const[userRoles,setUserRoles] = useState([]);
  const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
  const[userOrderDetails,setUserOrderDetails] = useState({});
  const[userSlug,setUserSlug] = useState({});
  const[drupalUID,setDrupalUID] = useState({});
  const[certificateCount,setCertificateCount] = useState({});
  const[agentscoutstatus,setAgentScoutStatus] = useState([]);
  const[introemails,setIntroEmails] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const[pageloadonteam,setIsPageLoadOnTeam] = useState(false);
  const[totalamount,setTotalAmount] = useState(0.0);
  const[success,setSuccess] = useState('');
  const editor_ref = React.useRef(null);
  const [IsSortFlagModalOpen, setIsSortFlagModalOpen] = useState(false);
  const[sortflagList, setSortflagList] = useState({});
  const[sortflagValue, setSortflagValue] = useState({});
  const[showIntroEmailModal, setShowIntroEmailModal] = useState(false);
  const [introemaildetailedview, setIntroEmailDetailedView] = useState({});
   const [productCount, setProductCount] = useState({});
  

  const initialIntroEmailForm = {
      email:'',
      name:'',
      drupal_uid:'',
      course_code:'',
      subject:'',
      body:'',
      loggedin_user_email:'',
      loggedin_user_name:''

    };
    const [formIntroEmailData, setFormIntroEmailData] = useState(initialIntroEmailForm);

  const location  = useLocation();
  const drupal_uid = localStorage.getItem('drupal_uid');
  const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
   var loggedin_domain = drupal_domain_url;
  if(localStorage.getItem('loggedin_domain')) {
    loggedin_domain = localStorage.getItem('loggedin_domain');
  } 
  var {uid} = useParams();
  console.log(uid+'Hai');
  var {username} = useParams();
  if(location.state) {
    const { userId } = location.state;
    uid = userId;
   
  }
  const successMessage = location.state?.message; // Access the message
  const domainName = window.location.host.replace(/^https?:\/\//, '');

  const {tab} = useParams();
  
  const loggedin_uid = localStorage.getItem('uid');
  const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
  const navigate = useNavigate();
  
  const app_url = configData.APP_URL;

  const domain_url = configData.DOMAIN_URL;
  const currentPath = location.pathname;

      const hiddenPaths = [
    "/user/"+drupalUID+"/certificate",   
  ];
  let content;

  /* if (userRoles.includes(configData.ROLE_SALES_PEOPLE)) {
    content = <ViewSalespersonDashboard />;
  } else if (userRoles.includes(configData.ROLE_APPLICATION) || userRoles.includes(configData.ROLE_ATHLETE) || userRoles.includes(configData.ROLE_AGENT) || userRoles.includes(configData.ROLE_SCOUT)) {
    content = <ViewUserProfile uid={uid} totalamount={totalamount} userLoggedInRoles={userLoggedInRoles}/>;
  }  else {
    content = <p></p>;
  } */

  const handleOpenSortflagModal = () => {
    setIsSortFlagModalOpen(true);
  };
 
    const handleModalClose = (modalname) => {
        if(modalname == 'sortflag') {
        setIsSortFlagModalOpen(false); 
        }
        if(modalname == 'intro_email') {
        setShowIntroEmailModal(false);
        }
        
    };
  const formatResult = (item) => {
    return (
      <>
        
        <span style={{ display: 'block', textAlign: 'left' }}>{item.name}</span>
      </>
    )
  }
  
   const doBackAway = () => {
  
    if (window.history.length > 1) {
        navigate(-1); // Go back
    } else {
        navigate('/'); // Fallback to home
    }
  };
 const handleOpen = () => {
    setSortflagValue();

  };
   const handleOnSortflagSelect = (item) => {
    // the item selected
    setSortflagValue(item.id);
  }
  const handleSortflagSubmit = async event => {
    event.preventDefault();
    
      const postData = {
        tid:sortflagValue,
        uid:drupalUID
      };
      const response = await fetch(app_url + 'sortflag/addsortflag', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
        if(data.data.msg === "Success") {
              
               setIsSortFlagModalOpen(false); 
               window.location.reload();
        } else {
            alert(data.data.text);
        }
       
    
  };
  const handleAgentInvite = async () => {
    
    
      const postData = {
        uid:drupalUID
      };
      const response = await fetch(app_url + 'smwwagency/agentinvite', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
        if(data.data.msg === "Success") {
        
               setSuccess(data.data.result);
        }
       
    
  };
  const handleScoutInvite = async () => {
    
    
      const postData = {
        uid:drupalUID
      };
      const response = await fetch(app_url + 'smwwscout/scoutinvite', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
        if(data.data.msg === "Success") {
        
               setSuccess(data.data.result);
        }
       
    
  };
  function updateToggle(id){
    setToggle(id);
    
    if(id == 1) { 
      //navigate("/users/"+userSlug,{state:uid});
      window.location.href = "/user/"+drupalUID;
    }
    if(id == 2) { 
      navigate("/user/"+drupalUID+"/edit");
    }
    if(id == 3) navigate("/user/"+drupalUID+"/my_orders");
    if(id == 4) { 
      navigate("/user/"+drupalUID+"/myreferral");
    }
    if(id == 8) navigate("/user/"+drupalUID+"/certificate");
    if(id == 7) navigate("/user/"+drupalUID+"/edit_mentor");
    if(id == 6) navigate("/user/"+drupalUID+"/edit_agent");
    if(id == 5) navigate("/user/"+drupalUID+"/edit_scout");
    if(id == 9) navigate("/user/"+drupalUID+"/edit_ambassador");
  }
  useEffect(() => {
    Promise.all([
      retrieveUserProfileDetails(),
    retrieveUserOrderDetails(),
    retrieveUserCertificateDetails(),
    retrieveSortFlags(),
    retrieveIntroEmails()
    ]).then(() => {
     
      setIsLoading(false);
      if(tab == "my_orders") {
      setToggle(3);

    }
    if(tab == "edit") {
      setToggle(2);
    }
    if(tab == "myreferral") {
      setToggle(4);

    }
    if(tab == "edit_scout") {
      setToggle(5);
    }
    if(tab == "edit_agent") {
      setToggle(6);
    }
    if(tab == "certificate") {
      setToggle(8);
       //window.location.href = loggedin_domain+"/user/"+drupalUID+"/certificate";
    }
    if(tab == "edit_mentor") {
      setToggle(7);
    }
     if(tab == "edit_ambassador") {
      setToggle(9);
    }
     });
    
    
  },[]);


  
  async function retrieveUserDetailsByUsername() {
    
    if(username) {
      try {
        setIsLoading(true);
    const response = await fetch(
      app_url+'viewprofile/getuserdetailsbyusername?username='+username,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.result === "Success") {
      
     
      setTotalAmount(responsedata.data.total_amount_paid);
      setDrupalUID(responsedata.data.user.drupal_uid);
     
      if(location.pathname.indexOf("user") > -1) {
        if(tab != "my_orders" && tab != 'edit' && tab != 'myreferral') {
        navigate("/users/"+responsedata.data.user_slug,{state:responsedata.data.user.drupal_uid});
        }
      }
     
       if(responsedata.data.logged_in_user_roles) {
          setUserLoggedInRoles(responsedata.data.logged_in_user_roles)
       }
      
      setUserSlug(responsedata.data.user_slug);
    }
     }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
           
          }
  }
  }
   async function retrieveUserProfileDetails() {
    
    if(uid!='' || username!='') {
      try {
        setIsLoading(true);
    const response = await fetch(
      app_url+'viewprofile/getuserprofiledetails?uid='+uid+'&username='+username,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.result === "Success") {
      uid = responsedata.data.user.drupal_uid;
      if(responsedata.data.date_of_app) responsedata.data.user.date_of_app = responsedata.data.date_of_app;
      setUserDetails(responsedata.data.user);
      setTotalAmount(responsedata.data.total_amount_paid);
      setProductCount(responsedata.data.product_count)
      setDrupalUID(responsedata.data.user.drupal_uid);
      setUserLoggedinDetails(responsedata.data.logged_in_user);
      setUserAssets(responsedata.data.user_assets);
      setUserAthleteAssets(responsedata.data.user_athlete_assets);
      
        setUserMentorAssets(responsedata.data.user_mentor_assets);
      setUserEventAssets(responsedata.data.user_event_attendee_assets);
       setUserAgentAssets(responsedata.data.user_agent_assets);
       setUserScoutAssets(responsedata.data.user_scout_assets)
       setUserAmbassadorAssets(responsedata.data.user_ambassador_assets);
       setUserCommonAssets(responsedata.data.user_common_assets);
       setUserLeadAssets(responsedata.data.user_lead_assets);
       setUserSocailMediaAssets(responsedata.data.social_media_assets);
      setUserSortflags(responsedata.data.user_sort_flags);
      setAgentScoutStatus(responsedata.data.agent_scout_status);
      if(responsedata.data.user_roles) {
        setUserRoles(responsedata.data.user_roles);
      }
      if(responsedata.data.logged_in_user_roles) {
        setUserLoggedInRoles(responsedata.data.logged_in_user_roles)
      }
      setUserSlug(responsedata.data.user_slug);
      if(location.pathname.indexOf("user/") > -1) {
       
        if(tab != "my_orders" && tab != 'edit' && tab != 'myreferral') {
          navigate("/users/"+responsedata.data.user_slug,{state:{userId: responsedata.data.user.drupal_uid}});
        }
      } else {
      navigate("/users/"+responsedata.data.user_slug,{state:{userId: responsedata.data.user.drupal_uid}});
      }
    }
    }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            
          }
  }
  }
  async function retrieveUserCertificateDetails() {
    
    if(drupalUID && !Number.isNaN(drupalUID)) {
    const response = await fetch(
      app_url+'certificate/getcertificatelist?uid='+uid+'&username='+username,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.result === "Success") {
      setCertificateCount(responsedata.data.count);
    }
  }
  }
  async function retrieveUserOrderDetails() {
    if(drupalUID) {
    const response = await fetch(
      app_url+'myorder/getuserorderdetails?uid='+uid+'&username='+username,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data) {
    setUserOrderDetails(responsedata.data); 
    console.log("test");
    } 
  }
  }
  async function  retrieveSortFlags() {
    
    if(drupalUID && !Number.isNaN(drupalUID)) {
    const response = await fetch(
      app_url+'sortflag/getnewsortflaglist',
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
      setSortflagList(responsedata.data.result);
    }
  }
  }
   async function retrieveIntroEmails() {
    
    if(drupalUID && !Number.isNaN(drupalUID)) {
       try {
        setIsLoading(true);
    const response = await fetch(
      app_url+'emails/getintroemaillist',
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
      setIntroEmails(responsedata.data.result);
      
    }
    }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            
          }
  }
  }

  const handleIntroEmailModalOpen = async (code,name) => {
    
    setShowIntroEmailModal(true);
      if(drupalUID && !Number.isNaN(drupalUID)) {
        try {
          const response =  await fetch(
          app_url+'emails/getintroemaildetailedview?uid='+drupalUID+'&code='+code,
          {
            method: "GET",
  
            headers: {
              'Content-Type': 'application/json',
            },
          }
          )
          const responsedata =  await response.json();
                
          if(responsedata.data.msg == "Success") {
            //setIntroEmailDetailedView(responsedata.data.result);
            setFormIntroEmailData({
                email:responsedata.data.result.email,
                subject:responsedata.data.result.subject,
                name:responsedata.data.result.name,
                drupal_uid:responsedata.data.result.drupal_uid,
                body:responsedata.data.result.body,
                loggedin_user_email:responsedata.data.result.loggedin_user_email,
                loggedin_user_name:responsedata.data.result.loggedin_user_name,
                course_code:name
            });
           
            } 
          } catch (err) {
            }
      }
        
   };
    const handleImpersonate = async (drupalUID) => {
    
   
      if(drupalUID && !Number.isNaN(drupalUID)) {
        try {
          setIsLoading(true);
          const response =  await fetch(
          app_url+'site/impersonateuser?uid='+drupalUID,
          {
            method: "GET",
  
            headers: {
              'Content-Type': 'application/json',
            },
          }
          )
          const responsedata =  await response.json();
                
          if(responsedata.data.msg == "Success") {
            window.location.reload();
            } 
          } catch (err) {
            }finally {
            setIsLoading(false);
          }
      }
        
   };
   const handleIntroEmailSubmit = async event => {
    event.preventDefault();
    
      const response = await fetch(app_url + 'emails/sendintroemail', {
        method: 'POST',
        body: JSON.stringify(formIntroEmailData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
        if(data.data.msg === "Success") {
               
               setShowIntroEmailModal(false); 
               window.location.reload();
               
        } else {
          alert("Error!");
        }
       
    
  };
 
  return (
   <>
   {isLoading ? (
        <Loading />
      ) : (
    <div id="main">
 
      <div class="left"></div>

      <div class="center left-center view-profile-wrapper">
        <Helmet>
          <title>{userDetails.email}</title>
        </Helmet> 
         {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
                        {success && (
                          <><br></br>
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {success}
                        </div></>
                        )}
     {loggedin_uid && !Number.isNaN(loggedin_uid) && (
      <>
  {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
    userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
    userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) || drupal_uid == uid ) ? (
      <><h2 class="element-invisible">Primary tabs</h2>
      <ul class="tabs primarya">
        <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}><a>View<span class="element-invisible">(active tab)</span></a></li>
        {userRoles.includes(configData.ROLE_AGENT) && (
        <li className= {toggle === 6? "active" : ""} onClick={()=> updateToggle(6)}><a>Edit Agent</a></li>
        )}
        {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
          userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
          userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) && (userRoles.includes(configData.ROLE_GLOBAL_AMBASSADOR)) && (
        <li className= {toggle === 9? "active" : ""} onClick={()=> updateToggle(9)}><a>Edit Ambassador</a></li>
        )}
        {userRoles.includes(configData.ROLE_MENTOR) && (
        <li className= {toggle === 7? "active" : ""} onClick={()=> updateToggle(7)}><a>Edit Mentor</a></li>
        )}
         
        <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}><a>Edit Profile</a></li>
         {userRoles.includes(configData.ROLE_SCOUT) && (
        <li className= {toggle === 5? "active" : ""} onClick={()=> updateToggle(5)}><a>Edit Scout</a></li>
        )}
        <li className= {toggle === 3? "active" : ""} onClick={()=> updateToggle(3)}><a>My Orders</a></li>
        <li className= {toggle === 4? "active" : ""} onClick={()=> updateToggle(4)}><a>My Referral Wallet</a></li>
        {certificateCount > 0 && (
        <li className= {toggle === 8? "active" : ""} onClick={()=> updateToggle(8)}><a>My Credentials</a></li>
        )}
      </ul></>  
    ) : (
      <></>
    )}  
    </>
      )}
      <div  className= {toggle === 1? "show-content" : "content"} style={userCommonAssets.field_dormant === 1 ? { backgroundColor: '#63686e',color:'#fff',padding:'8px' } : {}}>
        <div class="profile" typeof="sioc:UserAccount" >
          {(userRoles.includes(configData.ROLE_SALES_PEOPLE) && loggedin_drupal_uid == uid) && (
          <><div class="domain-alert">Trying to access your SMWW Agency account? <a href="https://betasmwwagency.preferati.net/user/1446" target="_blank">Click here</a>.</div></>
          
          )}
          {((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))) && (
          <><div className="user-profile-buttons">
            {userRoles.includes(configData.ROLE_APPLICATION) && 
            
            <>
            {loggedin_drupal_uid != uid && (
            <><a href style={{cursor:'pointer'}} class="masquerade-switch" onClick={() => handleImpersonate(drupalUID)}>Impersonate this user</a>&nbsp;&nbsp;</>
            )}
            <input type="button" name="send_agent_invite" id="send_agent_invite" value="Send Agent Invite" onClick={() => handleAgentInvite()}/>
          <input type="button" name="send_scout_invite" id="send_scout_invite" value="Send Scout Invite" onClick={() => handleScoutInvite()}/>
          <a href={'/add_to_earena/'+drupalUID} target="_blank"><input type="button" name="add_to_earena" id="add_to_earena" value="Add to E-Arena"/></a></> }

          <input type="button" name="add_sortflag" id="add_sortflag" value="Add SortFlag" onClick={() => handleOpenSortflagModal()}/>
           
          </div>
          </>
          
          )}
          {(domainName != configData.RSMWW_AGENCY_DOMAIN && domainName != configData.RSMWW_SCOUT_DOMAIN) ? (
          <>
          <div class="user-image" style={{ marginRight: '2%' }}>
          {userDetails.picture ? (  
            <><img  src={userDetails.picture} width="100px" height="100px" alt = "user"/></>
          ):(
            <><img  src={domain_url+"pictures/notavailable.jpg"} width="100px" height="100px" alt = "user"/></>
          )}
           </div>
           
          <div class="user-name-loc">
            <span class="user-name" style={{marginBottom:"5px"}}>{userDetails.first_name} {userDetails.last_name}</span>
             {userRoles.includes(configData.ROLE_MENTOR) && (
              <><span class="user-name" style={{marginBottom:"5px",fontSize:'16px'}}>{userCommonAssets.field_mentor_title}</span></>
             )}
            <span class="user-loc" style={{marginBottom:"5px"}}>{userDetails.city && userDetails.city+', '} 
              {userDetails.state && userDetails.state+', '} {userDetails.country && userDetails.country}</span>
              {!userRoles.includes(configData.ROLE_MENTOR) && (
                <span style={{ backgroundColor: '#FFFF00', padding: '8px', color: '#000' }}><strong>Recent app: {userCommonAssets.field_date_of_app}</strong></span>
              )}
          </div>
           {((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) || userLoggedInRoles.includes(configData.ROLE_APPLICATION))) && (
          <div class="user_total_amount" style={{ float: 'right', fontWeight: 'bold', fontSize: '16px' }}>Total Purchased: ${totalamount}</div> 
           )}
           </>
          ):(
            <></>
          )}
              {userRoles.includes(configData.ROLE_MENTOR) && (
           <div style={{textAlign:'right'}}><a href="javascript:void(0);" onClick={doBackAway}>« Back</a></div>
              )}
        </div>
        <div className="dashboard-content">
           {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) && loggedin_drupal_uid == uid) ? (
               <ViewSaadminDashboard userLoggedInRoles={userLoggedInRoles}/>
           ) :
           (userLoggedInRoles.includes(configData.ROLE_SAADMIN) && loggedin_drupal_uid == uid) ? (
               <ViewSaadminDashboard userLoggedInRoles={userLoggedInRoles}/>
           ) : (userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) && loggedin_drupal_uid == uid) ? (
              <ViewSalespersonDashboard />
        ) : (userLoggedInRoles.includes(configData.ROLE_AGENT) && domainName === configData.RSMWW_AGENCY_DOMAIN && loggedin_drupal_uid == uid) ? (
            <>
            {(userLoggedInRoles.includes(configData.ROLE_SCOUT)) && ( 
              <div className='domain-alert'>
                Trying to access your SMWW Scout account? 
                <a href={"https://"+configData.RSMWW_SCOUT_DOMAIN+"/users/"+username} target="_blank" style={{color: "#2c99d2"}}> Click here</a>.
              </div>
            )}
              <AgentHome userLoggedInRoles={userLoggedInRoles} uid={drupalUID} />
            </>
        ) : (userLoggedInRoles.includes(configData.ROLE_SCOUT) && domainName === configData.RSMWW_SCOUT_DOMAIN && loggedin_drupal_uid == uid) ? (
          <>
            {(userLoggedInRoles.includes(configData.ROLE_AGENT)) && ( 
              <div className='domain-alert'>
                Trying to access your SMWW Agency account? 
                <a href={"https://"+configData.RSMWW_AGENCY_DOMAIN+"/users/"+username} target="_blank" style={{color: "#2c99d2"}}> Click here</a>.
              </div>
            )}
              <ScoutHome userLoggedInRoles={userLoggedInRoles} uid={drupalUID} />
          </>
        ) :(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) ) ? (
       <ViewUserProfile uid={drupalUID} totalamount={totalamount} userLoggedinDetails={userLoggedinDetails} userLoggedInRoles={userLoggedInRoles} userDetails={userDetails} userAssets={userAssets} 
       userAthleteAssets={userAthleteAssets} userMentorAssets={userMentorAssets} userAgentAssets={userAgentAssets} userScoutAssets={userScoutAssets} userAmbassadorAssets={userAmbassadorAssets} 
       userCommonAssets={userCommonAssets} userLeadAssets = {userLeadAssets}   userEventAssets = {userEventAssets} userSortflags={userSortflags} userRoles={userRoles} 
       productCount={productCount} agentscoutstatus={agentscoutstatus}/>
      ) :(userRoles.includes(configData.ROLE_MENTOR) ? (
          <><div dangerouslySetInnerHTML={{ __html: userCommonAssets.field_biography }}></div></>
         ) : (
          <></>
         )
        
      )
    }
      </div>
       
         
      </div>
      <div  className= {toggle === 6? "show-content" : "content"}>
        <EditAgent uid={drupalUID}  userLoggedInRoles={userLoggedInRoles} userAgentAssets={userAgentAssets} userSocailMediaAssets={userSocailMediaAssets} userDetails={userDetails} userCommonAssets={userCommonAssets}/>
      </div>
       <div  className= {toggle === 9? "show-content" : "content"}>
        <EditAmbassador uid={drupalUID} userLoggedInRoles={userLoggedInRoles} userSocailMediaAssets={userSocailMediaAssets} picture={userDetails.picture} userAmbassadorAssets={userAmbassadorAssets} userCommonAssets={userCommonAssets}/>
      </div>
      <div  className= {toggle === 7? "show-content" : "content"}>
        <EditMentor uid={drupalUID} userLoggedInRoles={userLoggedInRoles} userMentorAssets={userMentorAssets}/>
      </div>
      <div  className= {toggle === 2? "show-content" : "content"}>
        {/* <EditProfile uid={drupalUID} userLoggedInRoles={userLoggedInRoles} userRoles={userRoles} userAgentAssets={userAgentAssets} userScoutAssets={userScoutAssets} userAthleteAssets={userAthleteAssets} userAmbassadorAssets={userAmbassadorAssets} userLeadAssets = {userLeadAssets} userMentorAssets={userMentorAssets} userEventAssets = {userEventAssets}/> */}
        {((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR))) ? (
          <AdminEditProfile uid={drupalUID} userLoggedInRoles={userLoggedInRoles} picture={userDetails.picture} userRoles={userRoles} userAgentAssets={userAgentAssets} userScoutAssets={userScoutAssets} userAthleteAssets={userAthleteAssets} userAmbassadorAssets={userAmbassadorAssets} userLeadAssets = {userLeadAssets} userMentorAssets={userMentorAssets} userEventAssets = {userEventAssets}/>
        ) : (
          <EditProfile uid={drupalUID} userLoggedInRoles={userLoggedInRoles} userRoles={userRoles} userAgentAssets={userAgentAssets} userScoutAssets={userScoutAssets} userAthleteAssets={userAthleteAssets} userAmbassadorAssets={userAmbassadorAssets} userLeadAssets = {userLeadAssets} userMentorAssets={userMentorAssets} userEventAssets = {userEventAssets}/>
        )}
      </div>
      <div  className= {toggle === 5? "show-content" : "content"}>
        <EditScout uid={drupalUID} userLoggedInRoles={userLoggedInRoles} userScoutAssets={userScoutAssets}/>
      </div>
      <div  className= {toggle === 3? "show-content" : "content"}>
        <OrderPage data={userOrderDetails} userLoggedInRoles={userLoggedInRoles}/>
      </div>
      <div  className= {toggle === 4? "show-content" : "content"}>
        <ReferralPage uid={drupalUID} userLoggedInRoles={userLoggedInRoles}/>
      </div>
      <div  className= {toggle === 8? "show-content" : "content"}>
        <CertificatePage uid={drupalUID} userDetails={userDetails}/>
      </div>

      {IsSortFlagModalOpen && (
        <>
         <div className="ad-modal-overlay add-sortflag">
                    <div className="ad-modal">
                        <button className="adm-close-button" onClick={() => handleModalClose('sortflag')}>×</button>
                        
                        <h2>Add Sortflag</h2>
                        <hr/>
                        <form className='ad-modal-form'>
                          <table>
                            <tr><td>
                           <label>Sortflags:</label></td>
                           <td> <div className="auto-complete">
                            {/* <ReactSearchAutocomplete
            items={sortflagList}
            
            onSelect={handleOnSortflagSelect}
           formatResult={formatResult} 
            autoFocus
            resultsContainerStyle={{
    width: '100%', // Adjust width as needed
  }}
          />*/}
           <Select 
                    
                    id="sortflag" name="sortflag" 
                    searchable={true}
                    required={true}  
                    clearable={true} 
                    clearOnBlur={true} 
                    clearOnSelect={true}
                    backspaceDelete={true} 
                     isOpen={true}
                    
                    style={{backgroundColor:'#ffffff', width:'87.8%', borderRadius: 5}}
                                        
                    options={sortflagList} 
                    onChange={(val) => {
                      if(val.length == 0) {
                        console.log(val);
                      }
                      else{
                        setSortflagValue(val[0]['value']);
                     
                      
                      }}
                    }
                    onDropdownOpen={handleOpen}
                    
                    
                    />
          </div>
                            </td>
                          </tr>
                          <tr><td></td><td align="right"><button type="submit" onClick={handleSortflagSubmit}>Submit</button></td></tr></table>
                       
                        </form>
                    </div>
                </div>
       </>
      )}
      {showIntroEmailModal && (           
<div id="myModal" class="modal intro-email-modal">

 
  <div class="modal-content">
    <div class="modal-header">
      <span class="close"  style={{'cursor':'pointer'}} onClick={() => handleModalClose('intro_email')}>&times;</span>
      <h2>Send Mail</h2>
    </div>
    <div class="modal-body">
        <form className="form_sendmail" id="form_sendMail" method="post">
        
        <p class="course-details">Course Details: <strong>{formIntroEmailData.course_code}</strong> </p>
        <div class="form-group">
            <label>Name: </label>
            <span class="input-firstname">{formIntroEmailData.name}</span>
        </div>
        <div class="form-group">
            <label>Application's Email: </label>
            <span class="input-email">{formIntroEmailData.email}</span>
        </div>
        <div class="form-group">
          <label>From Address: </label>
            <input class="form-control" id="drip-sal" name="salutation" type="text" value={formIntroEmailData.loggedin_user_email+', '+formIntroEmailData.loggedin_user_name}/>
        </div>
		<div class="form-group">
   <label>Email Content: </label>
           
       <Editor value={formIntroEmailData.body} onChange={(e) =>
                                           setFormIntroEmailData((prev) => ({ ...prev, body: e.target.value }))
   }>
        <Toolbar>
            <BtnBold />
            <BtnItalic />
            <BtnUndo/>   
            <BtnRedo/>                                                
        </Toolbar>
      </Editor>
                                          
 </div>

	</form>
    </div>
    <div class="modal-footer">
     <button type="button" className="sendemailIntroBtn" onClick={handleIntroEmailSubmit} role="button"><span class="ui-button-text">Send Email</span></button>
    </div>
  </div>

</div>
  )}
    </div>

    

{/* {!hiddenPaths.includes(currentPath) && ( */}
{toggle !== 8 && (
<div class="right">
 
  {((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) )) ? (
    <>
     {domainName === configData.RSMWW_DOMAIN && 
                <SalespersonSidebar/>
              }
              {domainName === configData.RSMWW_AGENCY_DOMAIN && 
                <AgentBackendSidebar/>
              }
               {domainName === configData.RSMWW_SCOUT_DOMAIN && 
                <ScoutSidebar/>
              }
              
      <div className="intro_emails"><h1>Send Email</h1>
      {introemails.length > 0 && (
            <><ul style={{'padding-left':'0px'}}>
            {introemails.map((item, index) => {
                return <>
                {item['name'] != null && (
                    <><li><a href onClick={() => handleIntroEmailModalOpen(item['code'],item['name'])}>{item['name']}</a></li></>
                )}
                </>
                    
            })}  
           </ul>
          </>
        )}
        </div>
      </>
  ) : (userLoggedInRoles.includes(configData.ROLE_AGENT) && domainName === configData.RSMWW_AGENCY_DOMAIN && loggedin_drupal_uid == uid) ? (
      <AgentBackendSidebar/>
  ) : (userLoggedInRoles.includes(configData.ROLE_SCOUT) && domainName === configData.RSMWW_SCOUT_DOMAIN && loggedin_drupal_uid == uid) ? (
      <ScoutSidebar/>
  ) : (userLoggedInRoles.includes(configData.ROLE_APPLICATION) && (
              
                <>
   <div className="salesperson-right">
            <div id="sidebar-third" className="salesperson-grid_4">
                <div className="salesperson-region salesperson-region-sidebar-third">
                    <div id="block-smww-smww-operations" className="salesperson-block salesperson-block-smww"></div>
                        <div>
                            <h1>Quick Links</h1>
                            <ul>
                                <li className='salesperson-header-hello-text'><a href={"/user/"+localStorage.getItem('uid')+"/edit"} className="salesperson-quick_link_anchor">Manage My Profile</a></li>
                                <li>
                                <a href="/smww_pay">
                                <input type="button" className='salesperson-quick-links-reg-button' value="Register for a Course"/>
                                </a>
                                </li>          
                                {localStorage.getItem('masquerade') == 1 && (
                                    <li>
                                    <a className="salesperson-quick_link_anchor" href={`/miscellaneous/charge/${drupal_uid}`}>
                                        Miscellaneous Charge
                                    </a>
                                    </li>
                                )}
                             </ul>
                          </div>
                        </div>   
                        </div>
                        </div></>
             )
             )}
</div>
 )}
  <div class="clear"></div> 
  
</div>
)}
    </>
    
    
  )
}

export default ViewTab